/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '2rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    margin: '20px auto',
    width: '601px',
    height: '646px',
    borderRadius: '6px',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '82vw !important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '79vw !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '39vw !important',
    },
    '& p': {
      color: '#B3261D',
      fontSize: '2rem !important',
      fontWeight: '400',
      lineHeight: '48px',
      fontFamily: 'Roboto Condensed !important',
      letterSpacing: '0px',
    },
  },
  cardContent: {
    minHeight: '300px',
  }
}));

export default function NoDataError() {
    const classes = useStyles();
    
    return (
      <>
            <div className={classes.cardContainer}>
                <div className={classes.cardContent}>
                    {/* Verify error message to Wayne */}
                    <p>We're sorry, there is no data to show here...</p> 
                </div>
            </div>
      </>
  
    );
  }
